module.exports = __webpack_public_path__ + "static/media/08B080A8-B961-475F-B930-807E8E722AFA.5463c0c1.bin";